const variants = {
  verde:    'bg-green-100 text-green-800',
  amarelo:  'bg-yellow-100 text-yellow-800',
  laranja:  'bg-orange-100 text-orange-800',
  vermelho: 'bg-red-100 text-red-800',
  azul:     'bg-blue-100 text-blue-800',
  roxo:     'bg-purple-100 text-purple-800',
  cinza:    'bg-gray-100 text-gray-700',
};

const statusMap = {
  pendente:             'amarelo',
  em_andamento:         'azul',
  aguardando_aprovacao: 'laranja',
  concluido:            'verde',
  cancelado:            'cinza',
  ativo:                'verde',
  inativo:              'cinza',
  rascunho:             'cinza',
  suspenso:             'laranja',
  encerrado:            'vermelho',
  pago:                 'verde',
  vencido:              'vermelho',
  estornado:            'roxo',
};

export default function Badge({ children, variant, status, className = '' }) {
  const v = variant || statusMap[status] || 'cinza';
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variants[v]} ${className}`}>
      {children}
    </span>
  );
}

export function UrgenciaBadge({ cor }) {
  return <Badge variant={cor}>{cor === 'vermelho' ? 'Vencido' : cor === 'laranja' ? 'Urgente' : cor === 'amarelo' ? 'Atenção' : 'No prazo'}</Badge>;
}
